<!-- <div class="order-complete-container">
  <div class="order-complete-content">
    <mat-icon class="success-icon" color="primary">check_circle</mat-icon>

    <h1>Your Order Is Completed!</h1>

    <p class="mat-body-1">
      Thank you for your order! Your order is being processed and will be completed within 3-6 hours. You will receive an email confirmation when your order is completed.
    </p>

    <button mat-flat-button color="primary" class="continue-shopping-button">
      Continue Shopping
    </button>

    <mat-divider></mat-divider>

    <h2>Order Details</h2>
  </div>
</div> -->


<div class="order-success-wrapper container" [style.background-color]="item.customField8">
    <div class="order-success-box">
        <div class="check-circle">
            <img  [style.height]="item.customField25"[style.width]="item.customField37" 
            [ngStyle.lt-md]="{height: item.customField26, width: item.customField38}" [src]="serverPath+item.customField6"
               [alt]="item.customField6.altImage || 'images'"  />
        </div>

        <h2 class="headers">
          <calsoft-editor-text [data]="data" [text]="item?.title" 
          [style.font-size]="item.customField31" [ngStyle.lt-md]="{ 'font-size': item.customField32 }">
          </calsoft-editor-text>
        </h2>

        <p class="order-message">
            <calsoft-editor-text [data]="data" [text]="item?.customField20" 
          [style.font-size]="item.customField33" [ngStyle.lt-md]="{ 'font-size': item.customField34 }">
          </calsoft-editor-text>
        </p>

        <button [style.background-color]="item.customField10" [style.color]="item.customField36"  [style.font-size]="item.customField29" [ngStyle.lt-md]="{ 'font-size': item.customField30 }"
           class="continue-button">{{item.customField24}}</button>

        <div fxLayout="row"  fxLayoutGap="10px" style="padding: 20px;" fxLayoutAlign="center center" >

            <div fxFlex="40" class="order-details-divider"></div>

            <h2 fxFlex [style.color]="item.customField35"
              [style.font-size]="item.customField27" [ngStyle.lt-md]="{ 'font-size': item.customField28 }"
            class="order-details-title">{{item.customField23}}</h2>
            <div fxFlex="40" class="order-details-divider"></div>
        </div>


    </div>
</div>